// extracted by mini-css-extract-plugin
export var formContainer = "_dx-0";
export var message = "_dx-1";